import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import AjBio from "@/pages/AjBio";

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.08, duration: 1.2, smoothWheel: true }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/team/aj-casavant" element={<AjBio />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </ReactLenis>
    </div>
  );
}

export default App;
